import axios, { AxiosError } from 'axios';

export const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'ek_admin_token';

export const tokenStore = {
  get: () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set: (t: string | null) => {
    try {
      if (t) localStorage.setItem(TOKEN_KEY, t);
      else localStorage.removeItem(TOKEN_KEY);
    } catch {
      /* ignore */
    }
  },
};

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.set('Authorization', `Bearer ${t}`);
  return cfg;
});

let refreshing: Promise<string | null> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (err: AxiosError) => {
    const cfg: any = err.config;
    const url = cfg?.url || '';
    if (err.response?.status === 401 && cfg && !cfg._retried && !url.includes('/auth/')) {
      cfg._retried = true;
      refreshing =
        refreshing ||
        api
          .post('/auth/refresh')
          .then((r) => {
            tokenStore.set(r.data.access_token);
            return r.data.access_token as string;
          })
          .catch(() => null)
          .finally(() => {
            setTimeout(() => (refreshing = null), 0);
          });
      const t = await refreshing;
      if (t) return api(cfg);
    }
    return Promise.reject(err);
  },
);

/** Media path from the API ("/api/files/..") -> absolute URL; bundled "/assets/.." paths stay relative. */
export function mediaUrl(p?: string | null): string {
  if (!p) return '';
  if (/^https?:\/\//.test(p)) return p;
  if (p.startsWith('/api/')) return `${BACKEND}${p}`;
  return `${process.env.PUBLIC_URL || ''}${p}`;
}

export function apiError(e: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const d: any = (e as any)?.response?.data?.detail;
  if (d == null) return (e as any)?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === 'string' ? x.msg : JSON.stringify(x))).join(' ');
  if (typeof d?.msg === 'string') return d.msg;
  return String(d);
}
